import { STATUS, type StatusKind } from '../lib/status'

export function StatusBadge({
  kind,
  compact = false,
}: {
  kind: StatusKind
  compact?: boolean
}) {
  const spec = STATUS[kind]
  return (
    <span
      className={`chip border ${spec.className}`}
      title={`${spec.label} — ${spec.description}`}
      aria-label={spec.label}
    >
      <span aria-hidden="true" className="font-bold leading-none">
        {spec.glyph}
      </span>
      {!compact && <span className="leading-none">{spec.short}</span>}
    </span>
  )
}

export function FallbackMarker({ compact = false }: { compact?: boolean }) {
  return (
    <span
      className="chip border border-ink-300 bg-ink-100 text-ink-600"
      title="Inherited from the platform's default project. Edit it here to create a client override."
      aria-label="Inherited from the default project"
    >
      <span aria-hidden="true">↳</span>
      {!compact && <span>inherited</span>}
    </span>
  )
}
